import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {DataService} from "../../../services/data.service";
import {GlobalConstants} from "../../../common/global-constants";
import {AuthenticationService} from "../../../services/authentication.service";
import {CommonUtils} from "../../../utils/common.utils";
import {DialogService} from "../../../services/dialog.service";

@Component({
  selector: 'app-transit-time-configuration',
  templateUrl: './transit-time-configuration.component.html',
  styleUrls: ['./transit-time-configuration.component.scss']
})
export class TransitTimeConfigurationComponent implements OnInit {

  transitTimeConfigurationForm: FormGroup;

  // All records fetched for the selected country, and the subset rendered in the table.
  transitTimeConfigurationRecords: any[] = [];
  transitTimeConfigurations: any[] = [];
  fromCountryCodeOptions: any[];

  loading = false;
  firstLoad = true;

  currentWorkingRecord: any;
  help_messages: any = this.dataService.help_messages;

  user: any = {};

  constructor(@Inject('CommonUtils') private readonly commonUtils: CommonUtils,
              @Inject('AuthenticationService') private readonly authenticationService: AuthenticationService,
              private formBuilder: FormBuilder,
              private toastrService: ToastrService,
              private dialogService: DialogService,
              private dataService: DataService) {
  }

  ngOnInit() {
    this.user = this.authenticationService.getUserDetails();
    this.transitTimeConfigurationForm = this.formBuilder.group({
      fromCountryCode: ['', Validators.required],
      businessUseCase: ['', Validators.required]
    });
    this.fromCountryCodeOptions = this.commonUtils.getFromCountryCodes();
  }

  get getItems() {
    return this.commonUtils.getItemsBasedOnArc();
  }

  public onFromCountryCodeChange(fromCountryCode: string) {
    this.loading = true;
    this.firstLoad = true;
    this.currentWorkingRecord = {};
    this.transitTimeConfigurations = [];
    this.transitTimeConfigurationForm.get(GlobalConstants.BUSINESS_USE_CASE).setValue('');
    this.dataService.getConfigurationRecordsBasedOnFromCountryCode(fromCountryCode).subscribe((data: any[]) => {
      this.loading = false;
      this.transitTimeConfigurationRecords = data[GlobalConstants.TRANSIT_TIME_CONFIGURATIONS_RESPONSE_KEY] || [];
    }, error => {
      this.loading = false;
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }

  public onBusinessUseCaseChange(businessUseCase) {
    this.currentWorkingRecord = this.commonUtils.getCurrentWorkingRecord(businessUseCase);
    this.transitTimeConfigurations = [];
    this.firstLoad = true;
  }

  public render() {
    this.firstLoad = false;
    this.transitTimeConfigurations = this.filterConfigurations();
  }

  private filterConfigurations(): any[] {
    const businessUnit = this.currentWorkingRecord[GlobalConstants.BUSINESS_UNIT];
    const fromCountryCode = this.transitTimeConfigurationForm.get(GlobalConstants.FROM_COUNTRY_CODE).value;
    return this.transitTimeConfigurationRecords.filter(record =>
      record[GlobalConstants.BUSINESS_UNIT] === businessUnit
      && record[GlobalConstants.FROM_COUNTRY_CODE] === fromCountryCode
      && record[GlobalConstants.COMPONENT_KEY_VALUE] != null);
  }

  public getMappedServicesDisplay(row): string {
    const mappedServices = row[GlobalConstants.MAPPED_SERVICES];
    return mappedServices && mappedServices.length > 0 ? mappedServices.join(', ') : 'none';
  }

  public openEditDialog(row) {
    const dialogData = {
      businessUnit: row[GlobalConstants.BUSINESS_UNIT],
      fromCountryCode: row[GlobalConstants.FROM_COUNTRY_CODE],
      componentKeyValue: row[GlobalConstants.COMPONENT_KEY_VALUE],
      transitTimeType: row[GlobalConstants.TRANSIT_TIME_TYPE],
      mappedServices: row[GlobalConstants.MAPPED_SERVICES] ? [...row[GlobalConstants.MAPPED_SERVICES]] : [],
      updatedBy: this.user[GlobalConstants.ALIAS],
      existingRecords: this.transitTimeConfigurations
    };
    this.dialogService.openEditTransitTimeConfigDialog(dialogData).subscribe((result: any) => {
      if (result && result.saved) {
        this.toastrService.success(result.message || GlobalConstants.REQUEST_SUCCESSFUL, GlobalConstants.TITLE_SUCCESS);
        this.reload();
      }
    });
  }

  private reload() {
    const fromCountryCode = this.transitTimeConfigurationForm.get(GlobalConstants.FROM_COUNTRY_CODE).value;
    this.loading = true;
    this.dataService.getConfigurationRecordsBasedOnFromCountryCode(fromCountryCode).subscribe((data: any[]) => {
      this.loading = false;
      this.transitTimeConfigurationRecords = data[GlobalConstants.TRANSIT_TIME_CONFIGURATIONS_RESPONSE_KEY] || [];
      this.transitTimeConfigurations = this.filterConfigurations();
    }, error => {
      this.loading = false;
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }
}
